export default __webpack_public_path__ + "static/bubble-with-categories-d09e5d9bc2f659956c200f3bda37203a.png";